import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Barrierefreiheit = () => {
  return (
    <main className="pt-16 lg:pt-20">
      <section className="section-padding bg-white" data-testid="barrierefreiheit-page">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-[#0F172A] mb-8 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Zurück zur Startseite</span>
            </Link>

            <h1 className="heading-lg text-[#0F172A] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Barrierefreiheit
            </h1>

            <div className="prose prose-slate max-w-none">
              <p className="text-slate-600 mb-4">
                Die DSG Beteiligungs- und Verwaltungsgesellschaft mbH ist bemüht, ihre Website möglichst barrierefrei zugänglich zu machen und kontinuierlich zu verbessern.
              </p>
              <p className="text-slate-600 mb-4">
                Diese Erklärung zur Barrierefreiheit gilt für die Website:<br />
                <a href="https://hospital-bess.de/" target="_blank" rel="noopener noreferrer" className="text-[#10B981] hover:underline">
                  https://hospital-bess.de/
                </a>
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Stand der Vereinbarkeit mit den Anforderungen
              </h2>
              <p className="text-slate-600 mb-4">
                Diese Website orientiert sich an den Anforderungen der Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) sowie an den internationalen Richtlinien der Web Content Accessibility Guidelines (WCAG).
              </p>
              <p className="text-slate-600 mb-4">
                Wir arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website weiter zu verbessern. Derzeit bestehen noch vereinzelt Barrieren, die im Rahmen der laufenden Weiterentwicklung reduziert werden.
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Maßnahmen zur Barrierefreiheit
              </h2>
              <p className="text-slate-600 mb-4">
                Zur Verbesserung der Zugänglichkeit wurden unter anderem folgende Maßnahmen umgesetzt:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-1">
                <li>strukturierte Seiteninhalte und nachvollziehbare Navigationslogik</li>
                <li>Bedienbarkeit über Tastatur (Tab-Navigation)</li>
                <li>Alternativtexte für relevante Bilder</li>
                <li>ausreichende Farbkontraste zur besseren Lesbarkeit</li>
                <li>responsive Darstellung für unterschiedliche Endgeräte</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Feedback und Kontakt
              </h2>
              <p className="text-slate-600 mb-4">
                Sollten Ihnen Barrieren auf unserer Website auffallen oder benötigen Sie Unterstützung beim Zugriff auf Inhalte, kontaktieren Sie uns gerne:
              </p>
              <p className="text-slate-600 mb-4">
                DSG Beteiligungs- und Verwaltungsgesellschaft mbH
              </p>
              <p className="text-slate-600 mb-4">
                E-Mail: <a href="mailto:info@hospital-bess.de" className="text-[#10B981] hover:underline">info@hospital-bess.de</a>
              </p>
              <p className="text-slate-600 mb-4">
                Telefon:<br />
                +49 176 93127245<br />
                +49 30 71047955
              </p>

              <h2 className="text-xl font-semibold text-[#0F172A] mt-8 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Aktualisierung dieser Erklärung
              </h2>
              <p className="text-slate-600 mb-4">
                Diese Erklärung wird regelmäßig überprüft und bei Bedarf aktualisiert.
              </p>

              <p className="text-slate-500 text-sm mt-12 pt-8 border-t border-slate-200">
                © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
